import {
  FILTERS_COMPONENT_DISEASE,
  FILTERS_COMPONENT_GROWTH_STAGES,
  FILTERS_COMPONENT_RISK_LEVEL,
  FILTERS_COMPONENT_TECHNICIAN
} from '@features/regional-overview/domain/tests-id.constants';
import type { Filter, RegionalOverviewFilterType } from '@features/regional-overview/regional-overview.models';
import { RegionalOverviewFilterType as FilterTypeEnum } from '@features/regional-overview/regional-overview.models';
import { useTranslation } from 'react-i18next';
import MultiSelectFilter from '../../components/multi-select-filter/multi-select-filter.component';
import { FILTER_ALL_OPTION_KEY, FILTER_SECTION_TITLE_KEY } from '../../filter-labels.utils';
import { useFiltersStore } from '../../filters.store';

const MULTI_SELECT_TEST_IDS: Partial<Record<RegionalOverviewFilterType, string>> = {
  [FilterTypeEnum.RISK_LEVEL]: FILTERS_COMPONENT_RISK_LEVEL,
  [FilterTypeEnum.TECHNICIAN]: FILTERS_COMPONENT_TECHNICIAN,
  [FilterTypeEnum.GROWTH_STAGES]: FILTERS_COMPONENT_GROWTH_STAGES,
  [FilterTypeEnum.DISEASE]: FILTERS_COMPONENT_DISEASE
};

interface MultiSelectSectionProps {
  filter: Filter;
  defaultExpanded?: boolean;
}

const MultiSelectSection = ({ filter, defaultExpanded }: MultiSelectSectionProps) => {
  const [t] = useTranslation();
  const titleKey = FILTER_SECTION_TITLE_KEY[filter.type];
  const options = useFiltersStore(state => state.options[filter.type] ?? []);
  const raw = useFiltersStore(state => state.values[filter.type]);
  const setValue = useFiltersStore(state => state.setValue);

  if (!titleKey || !options.length) return null;

  const allLabelKey = filter.includeAllOption ? FILTER_ALL_OPTION_KEY[filter.type] : undefined;

  return (
    <MultiSelectFilter
      filter={filter.type}
      title={t(titleKey)}
      options={options}
      allLabelKey={allLabelKey}
      translatable={filter.translatable}
      value={Array.isArray(raw) ? (raw as string[]) : undefined}
      onFilterChanged={(_t, v) => setValue(filter.type, v)}
      defaultExpanded={defaultExpanded}
      dataTestID={MULTI_SELECT_TEST_IDS[filter.type]}
    />
  );
};

export default MultiSelectSection;
